/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Settings_TitleInputs */



/**
* | output |
* | --- |
* | "Export Settings" |
*
* @param {Audio_Description_Export_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_settings_title = /** @type {((inputs?: Audio_Description_Export_Settings_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Settings_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres d'exportation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exporteinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di esportazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт настроек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de exportação")
	return /** @type {LocalizedString} */ ("Export Settings")
});